module.exports = __webpack_public_path__ + "static/media/pau-papel.336fe6f5.webp";